import { render, staticRenderFns } from "./index.vue?vue&type=template&id=015b0d4c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=015b0d4c&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015b0d4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015b0d4c')) {
      api.createRecord('015b0d4c', component.options)
    } else {
      api.reload('015b0d4c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=015b0d4c&scoped=true&", function () {
      api.rerender('015b0d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderSystem/components/dhShop/index.vue"
export default component.exports